import { BaseGridLayout } from '@lucan/base-ui'
import Titoletto from './Titoletto'
import { Box } from '@mui/material'

export default function ScatolaRisultatoRicerca(props) {
  const { Icona, titolo, propsIcona, children, ...rest } = props

  return (
    <Box {...rest}>
        <BaseGridLayout justifySpaceBetween alignCenter>
          <BaseGridLayout alignCenter>
            <Icona
              key='icona'
              color='default'
              {...propsIcona}
            />
            <Titoletto key='testo' variant='h5'>{titolo}</Titoletto>
          </BaseGridLayout>
        </BaseGridLayout>
        {children}
      </Box>
  )
}